/*
 * Puts the cursor in the phone search box once it has opened.
 *
 * Bootstrap's collapse opens and closes the box; it does not move focus, so
 * without this the icon needs a second tap on the field before typing.
 * Focusing waits for `shown` because a field inside a still-collapsing
 * element cannot take focus.
 */
const searchPanel = document.querySelector('[data-circles-header-search]');

if (searchPanel) {
  searchPanel.addEventListener('shown.bs.collapse', () => {
    const input = searchPanel.querySelector('input[type="search"]');
    if (input) input.focus();
  });
}
